import React from 'react';

const IconPrint = ({ onClick }) => {
	return (
		<div className='IconPrint' onClick={onClick}>
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_408_965)">
					<path d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78333 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78333 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.625 15 9.16667C15 8.70833 15.375 8.33333 15.8334 8.33333C16.2917 8.33333 16.6667 8.70833 16.6667 9.16667C16.6667 9.625 16.2917 10 15.8334 10ZM15 2.5H5.00002V5.83333H15V2.5Z" fill="#344054" />
				</g>
				<defs>
					<clipPath id="clip0_408_965">
						<rect width="20" height="20" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</div>
	)
}

export default IconPrint;